import { Button } from "@blueprintjs/core";
import { QuanLyHoSo, DuLieuHeThong, TrangChu } from "api";
import DataTable from "components/data-table";
import { Input } from "components/tt-forms/common";
import { API_URL } from 'constants/config';
import { exportExcel } from "constants/exportExcel";
import { header } from "constants/table";
import { MasterLayout } from "layout";
import { isEmpty } from "lodash";
import { RowItemDSQuanLyHoSo } from "modules/quan-ly-ho-so/datatable";
import React, { Component } from "react";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import { DropDown, DatePicker } from 'components/tt-forms/common';
import { get } from 'lodash';
import moment from 'moment';

class DanhSachQuanLyHoSo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0,
      },
      dataQuanLyHoSo: [],
      keyword: "",
      donViId: "",
      startDate: "",
      endDate: "",
      dataOptions: [],
      tableLoading: false,
      buttonLoading: false,
      searchLoading: false,
      search: false,
      isThanhTraTinh: false
    };
  }

  componentDidMount() {
    this.getListDV();
    this.getCheckThanhTraTinh();
  }

  componentDidUpdate() {
    if(isEmpty(this.state.dataOptions)) {
      this.getListDV();
    }
  }

  handleSearch(e) {
    e.preventDefault();
    this.setState({
      search: true
    });
    this.getListData(true);
  }

  getListData(isSearch) {
    this.setState({ tableLoading: true });

    if (isSearch) {
      this.setState({
        searchLoading: true
      });
    }
    let params = {
      page: isSearch ? 0 : this.state.pageData.number,
      size: this.state.pageData.size,
    };
    if (this.state.keyword) {
      params.keyword = this.state.keyword.trim();
    }
    if (this.state.donViId) {
      params.donViId = this.state.donViId;
    }
    if (this.state.startDate) {
      params.startDate = moment(this.state.startDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }
    if (this.state.endDate) {
      params.endDate = moment(this.state.endDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }
    QuanLyHoSo.actions.getDsQuanLyHoSo.request(null, params).then((res) => {
      if (res.data) {
        let data = res.data.contents;
        this.setState({
          ...this.state,
          dataQuanLyHoSo: data,
          tableLoading: false,
          searchLoading: false,
          pageData: {
            number: res.data.pageNumber,
            size: res.data.pageSize,
            totalElements: res.data.totalElements,
            totalPages: res.data.totalPages
          },
        })
      } else {
        this.setState({
          ...this.state,
          dataQuanLyHoSo: [],
          tableLoading: false,
          loading: false,
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0,
          },
        });
      }
    });
  }

  goBack() {
    browserHistory.goBack();
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value,
    });
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData();
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData();
  }

  handleExport() {
    const URL = String(API_URL) + "/ho-so-thanh-tra"
    exportExcel(URL, 'hosothanhtra.xlsx');
  }

  onKeyDown(e) {
    if (e.key === 'Enter') {
      this.getListData(true);
    }
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  getListDV() {
    DuLieuHeThong.actions.getDonViThongKe.request().then(res => {
      if (res.data) {
        this.setState({
          dataOptions: get(res.data, '_embedded.coQuanQuanLies')
        })
      }
    });
  }

  getCheckThanhTraTinh() {
    TrangChu.actions.getCheckLuaChonDonVi.request(null, {}).then(res => {
      const { data } = res;
      let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
      this.setState({
        ...this.state,
        isThanhTraTinh: data,
        donViId: !data ? userInfo.donViId : undefined
      }, () => {
        this.getListData()
      });
    })
  }

  render() {
    const dataCoQuanQuanLyList = this.state.dataOptions;
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container" ref="qlhs">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18">
                <i className="tt tt-thanh-tra"></i>Danh sách hồ sơ
              </p>
            </div>
          </div>
          <div className="bottom-content">
            <div className="wrap-block search_form_lichsu">
              <div className="row plr10">
                <div className="col-100 no-gutter">
                  <div className="search_form_ttt">
                    <Input
                      className="col-30"
                      placeholder="Nhập mã hồ sơ tìm kiếm"
                      value={this.state.keyword}
                      onChange={this.onChange.bind(this, "keyword")}
                      name="keyword"
                      onKeyDown={this.onKeyDown.bind(this)}
                    />
                    <DropDown
                      className='col-20'
                      label="Cơ quan lưu trữ"
                      options={dataCoQuanQuanLyList}
                      keyName="coQuanQuanLyId"
                      valueName="ten"
                      placeholder="Chọn"
                      selectedValue={this.state.donViId}
                      onChange={this.onChange.bind(this, 'donViId')}
                      disabled={!this.state.isThanhTraTinh}
                    />
                    <DatePicker
                      className='col-20'
                      label='Từ ngày'
                      onChange={this.handleChangeDate.bind(this, 'startDate')}
                      value={this.state.startDate}
                      endDate={new Date(this.state.endDate)}
                    />
                    <DatePicker
                      className='col-20'
                      label='Đến ngày'
                      onChange={this.handleChangeDate.bind(this, 'endDate')}
                      value={this.state.endDate}
                      startDate={new Date(this.state.startDate)}
                    />
                    <Button
                      className="btn-green ttt-search"
                      text="Tìm kiếm"
                      onClick={this.handleSearch.bind(this)}
                      disabled={this.state.searching ? "disabled" : ""}
                    />
                  </div>
                </div>
              </div>
            </div>
            <DataTable
              header={header.quanLyHoSo.dsQuanLyHoSo}
              dataList={this.state.dataQuanLyHoSo}
              handleExport={this.handleExport.bind(this)}
              exporttext="Xuất Excel"
              thanhTra
              hideButtonExport={true}
              pageData={this.state.pageData}
              parent={this}
              search={this.state.search}
              tableLoading={this.state.tableLoading}
            >
              <RowItemDSQuanLyHoSo />
            </DataTable>
          </div>
        </div>
      </MasterLayout>
    );
  }
}

export default connect()(DanhSachQuanLyHoSo);



// WEBPACK FOOTER //
// ./src/components/modules/quan-ly-ho-so/DanhSachQuanLyHoSo.jsx